import { useEffect } from 'react';

const STYLE = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Space+Mono:wght@400;700&display=swap');

  .bl-root { background: #F9F7F4; color: #1a1a1a; font-family: 'Space Mono', monospace; }

  /* ── HERO ── */
  .bl-hero {
    background: #FFF8EE; padding: 60px 40px 90px;
    position: relative; overflow: hidden; border-bottom: 1px solid #EDE8DE;
  }
  .bl-hero::before {
    content: ''; position: absolute; inset: 0;
    background-image: radial-gradient(circle, rgba(27,47,232,0.07) 1px, transparent 1px);
    background-size: 28px 28px; pointer-events: none;
  }
  .bl-hero::after {
    content: ''; position: absolute; top: 0; right: 0; bottom: 0; width: 55%;
    background: radial-gradient(ellipse 70% 80% at 85% 45%, rgba(255,214,0,0.13) 0%, transparent 65%);
    pointer-events: none;
  }
  .bl-hero-inner { max-width: 1100px; margin: 0 auto; position: relative; z-index: 2; display: grid; grid-template-columns: 1fr 1fr; align-items: center; gap: 60px; }
  .bl-hero-text { }

  /* ── HERO RIGHT VISUAL ── */
  .bl-hero-visual { position: relative; height: 420px; display: flex; align-items: center; justify-content: center; }

  /* glow backdrop */
  .bl-vis-glow { position: absolute; width: 220px; height: 220px; border-radius: 50%; background: radial-gradient(circle, rgba(27,47,232,0.14) 0%, rgba(255,214,0,0.07) 55%, transparent 75%); animation: bl-glow-pulse 4s ease-in-out infinite; }
  @keyframes bl-glow-pulse { 0%,100%{transform:scale(1);opacity:0.8} 50%{transform:scale(1.18);opacity:1} }

  /* main dark analytics card */
  .bl-vis-card { background: #18181B; border: 1px solid rgba(255,214,0,0.18); border-radius: 18px; padding: 22px 20px 18px; width: 258px; box-shadow: 0 28px 64px rgba(0,0,0,0.22), 0 0 0 1px rgba(255,255,255,0.04); position: relative; z-index: 2; animation: bl-card-float 5s ease-in-out infinite; }
  @keyframes bl-card-float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
  .bl-vis-card-hdr { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
  .bl-vis-card-title { font-family:'Bebas Neue',monospace; font-size:15px; letter-spacing:0.1em; color:#fff; }
  .bl-vis-live { display:flex; align-items:center; gap:5px; font-family:'Space Mono',monospace; font-size:8px; font-weight:700; letter-spacing:0.1em; color:#4ade80; }
  .bl-vis-live-dot { width:6px; height:6px; border-radius:50%; background:#4ade80; animation:bl-live-blink 1.4s ease-in-out infinite; }
  @keyframes bl-live-blink { 0%,100%{opacity:1;box-shadow:0 0 4px #4ade80} 50%{opacity:0.3;box-shadow:none} }

  /* animated bar chart */
  .bl-vis-bars { display:flex; align-items:flex-end; gap:8px; height:88px; margin-bottom:14px; padding-bottom:2px; border-bottom:1px solid rgba(255,255,255,0.08); }
  .bl-vis-bar-col { display:flex; flex-direction:column; align-items:center; gap:5px; flex:1; height:100%; justify-content:flex-end; }
  .bl-vis-bar { width:100%; border-radius:4px 4px 0 0; transform-origin:bottom; }
  .bl-bar-1 { height:80px; background:linear-gradient(180deg,#FFD600,#FF9800); animation:bl-bar-up 1.2s cubic-bezier(.34,1.56,.64,1) 0.3s both, bl-bar-live1 3.5s ease-in-out 1.5s infinite; }
  .bl-bar-2 { height:58px; background:linear-gradient(180deg,#1B2FE8,#5577FF); animation:bl-bar-up 1.2s cubic-bezier(.34,1.56,.64,1) 0.5s both, bl-bar-live2 4.0s ease-in-out 1.7s infinite; }
  .bl-bar-3 { height:70px; background:linear-gradient(180deg,#4ade80,#22c55e); animation:bl-bar-up 1.2s cubic-bezier(.34,1.56,.64,1) 0.7s both, bl-bar-live3 3.2s ease-in-out 1.9s infinite; }
  @keyframes bl-bar-up    { from{transform:scaleY(0)} to{transform:scaleY(1)} }
  @keyframes bl-bar-live1 { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(0.82)} }
  @keyframes bl-bar-live2 { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.12)} }
  @keyframes bl-bar-live3 { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(0.90)} }
  .bl-vis-bar-lbl { font-family:'Space Mono',monospace; font-size:7px; color:rgba(255,255,255,0.35); text-align:center; white-space:nowrap; letter-spacing:0.05em; }

  /* metrics row */
  .bl-vis-metrics { display:grid; grid-template-columns:1fr 1fr 1fr; gap:8px; margin-top:14px; }
  .bl-vis-metric { background:rgba(255,255,255,0.04); border:1px solid rgba(255,255,255,0.07); border-radius:8px; padding:9px 8px; }
  .bl-vis-metric-num { font-family:'Bebas Neue',monospace; font-size:18px; line-height:1; }
  .bl-vis-metric-lbl { font-family:'Space Mono',monospace; font-size:7px; color:rgba(255,255,255,0.35); letter-spacing:0.08em; text-transform:uppercase; margin-top:2px; }
  .bl-mn-1 { color:#FFD600; }
  .bl-mn-2 { color:#6C8EFF; }
  .bl-mn-3 { color:#4ade80; }

  /* floating badges */
  .bl-vis-float { position:absolute; background:#fff; border:1.5px solid #E8E4DC; border-radius:8px; padding:7px 12px; font-family:'Space Mono',monospace; font-size:8px; font-weight:700; color:#1a1a1a; white-space:nowrap; box-shadow:0 4px 16px rgba(0,0,0,0.09); z-index:3; }
  .bl-vis-float span { color:#1B2FE8; }
  .bl-vf-1 { top:6%;  right:2%;  animation:bl-flt-up 3.8s ease-in-out infinite; }
  .bl-vf-2 { bottom:16%; left:1%;  animation:bl-flt-dn 3.2s ease-in-out infinite 0.6s; }
  .bl-vf-3 { bottom:4%; right:5%;  animation:bl-flt-up 4.2s ease-in-out infinite 1.1s; }
  @keyframes bl-flt-up { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
  @keyframes bl-flt-dn { 0%,100%{transform:translateY(0)} 50%{transform:translateY(8px)} }

  @media(max-width:900px) { .bl-hero-inner { grid-template-columns:1fr; } .bl-hero-visual { display:none; } }
  .bl-eyebrow {
    display: inline-flex; align-items: center; gap: 8px;
    border: 1px solid rgba(27,47,232,0.2); border-radius: 2px;
    font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700;
    letter-spacing: 0.25em; color: #1B2FE8; padding: 6px 16px; margin-bottom: 28px;
    text-transform: uppercase; background: rgba(27,47,232,0.04);
  }
  .bl-hero-title {
    font-family: 'Bebas Neue', monospace;
    font-size: clamp(60px,9vw,112px); line-height: 0.92;
    letter-spacing: 0.01em; color: #1a1a1a; margin-bottom: 28px;
  }
  .bl-hero-title em { color: #1B2FE8; font-style: normal; display: block; }

  /* ── Cycling word ── */
  .bl-cycle { position:relative; display:inline-block; color:#1B2FE8; font-style:normal; }
  .bl-cycle-spacer { visibility:hidden; display:block; }
  .bl-cycle-word { position:absolute; top:0; left:0; opacity:0; white-space:nowrap;
    animation: bl-cycle-anim 10s linear infinite; }
  .bl-cw-0{animation-delay:0s} .bl-cw-1{animation-delay:2s} .bl-cw-2{animation-delay:4s}
  .bl-cw-3{animation-delay:6s} .bl-cw-4{animation-delay:8s}
  @keyframes bl-cycle-anim {
    0%  {opacity:0;transform:translateY(14px)}
    6%  {opacity:1;transform:translateY(0)}
    18% {opacity:1;transform:translateY(0)}
    24% {opacity:0;transform:translateY(-14px)}
    100%{opacity:0}
  }
  .bl-hero-desc { font-family: 'Space Mono', monospace; font-size: 12px; line-height: 2; color: #888; max-width: 540px; letter-spacing: 0.06em; }

  /* ── MARQUEE ── */
  .bl-marquee-bar { background: #0E0E10; padding: 14px 0; overflow: hidden; white-space: nowrap; border-top: 1px solid rgba(255,214,0,0.12); border-bottom: 1px solid rgba(255,214,0,0.12); }
  .bl-marquee-track { display: inline-flex; animation: bl-mq 22s linear infinite; }
  .bl-marquee-item { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.22em; color: rgba(255,255,255,0.4); padding: 0 32px; display: flex; align-items: center; gap: 16px; text-transform: uppercase; transition: color 0.2s, text-shadow 0.2s; cursor: default; }
  .bl-marquee-item:hover { color: #FFD600; text-shadow: 0 0 10px rgba(255,214,0,0.9), 0 0 24px rgba(255,214,0,0.5); }
  .bl-mq-dot { display: inline-block; width: 4px; height: 4px; background: #FFD600; border-radius: 50%; flex-shrink: 0; }
  @keyframes bl-mq { from{transform:translateX(0)}to{transform:translateX(-50%)} }

  /* ── FEATURED POST ── */
  .bl-featured-section { background: #F9F7F4; padding: 60px 40px 60px; }
  .bl-featured-inner { max-width: 1100px; margin: 0 auto; }
  .bl-section-eyebrow { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.3em; text-transform: uppercase; color: #999; margin-bottom: 16px; }
  .bl-section-title { font-family: 'Bebas Neue', monospace; font-size: clamp(40px,5vw,68px); letter-spacing: 0.02em; color: #1a1a1a; margin-bottom: 28px; line-height: 1; }
  .bl-section-title em { color: #1B2FE8; font-style: normal; }
  .bl-featured-card {
    display: grid; grid-template-columns: 1fr 1fr; gap: 0;
    background: #E8E4DC; border: 1px solid #E8E4DC;
  }
  .bl-featured-img {
    background: linear-gradient(135deg, #0D0D14 0%, #0E1A5E 60%, #1B2FE8 100%);
    min-height: 340px; display: flex; align-items: center; justify-content: center;
    position: relative; overflow: hidden;
  }

  /* grid overlay */
  .bl-fi-grid { position:absolute; inset:0;
    background-image: linear-gradient(rgba(27,47,232,0.18) 1px,transparent 1px), linear-gradient(90deg,rgba(27,47,232,0.18) 1px,transparent 1px);
    background-size: 36px 36px; pointer-events:none; }

  /* big ghost SEO behind everything */
  .bl-fi-ghost { position:absolute; font-family:'Bebas Neue',monospace; font-size:clamp(80px,12vw,140px);
    letter-spacing:0.04em; color:rgba(255,214,0,0.06); user-select:none; pointer-events:none;
    animation:bl-fi-ghost-pulse 4s ease-in-out infinite; }
  @keyframes bl-fi-ghost-pulse { 0%,100%{opacity:0.5} 50%{opacity:1} }

  /* central glowing SEO word */
  .bl-fi-center { position:relative; z-index:2; display:flex; flex-direction:column; align-items:center; gap:10px; }
  .bl-fi-seo { font-family:'Bebas Neue',monospace; font-size:clamp(54px,7vw,88px); letter-spacing:0.08em;
    color:#FFD600; line-height:1;
    text-shadow: 0 0 20px rgba(255,214,0,0.9), 0 0 50px rgba(255,214,0,0.6), 0 0 90px rgba(255,214,0,0.3);
    animation:bl-fi-glow 2.8s ease-in-out infinite; }
  @keyframes bl-fi-glow {
    0%,100%{ text-shadow:0 0 20px rgba(255,214,0,0.9),0 0 50px rgba(255,214,0,0.6),0 0 90px rgba(255,214,0,0.3); }
    50%    { text-shadow:0 0 30px rgba(255,214,0,1),  0 0 80px rgba(255,214,0,0.85),0 0 140px rgba(255,214,0,0.5); }
  }
  .bl-fi-rank { display:flex; align-items:center; gap:8px; background:rgba(255,214,0,0.1); border:1px solid rgba(255,214,0,0.35); border-radius:4px; padding:6px 14px; }
  .bl-fi-rank-num { font-family:'Bebas Neue',monospace; font-size:22px; color:#FFD600; line-height:1; }
  .bl-fi-rank-lbl { font-family:'Space Mono',monospace; font-size:8px; font-weight:700; letter-spacing:0.15em; color:rgba(255,255,255,0.6); text-transform:uppercase; }

  /* floating keyword pills */
  .bl-fi-pill { position:absolute; z-index:3; font-family:'Space Mono',monospace; font-size:8px; font-weight:700; letter-spacing:0.1em; text-transform:uppercase;
    background:rgba(255,255,255,0.07); border:1px solid rgba(255,255,255,0.15); border-radius:20px;
    padding:5px 12px; color:rgba(255,255,255,0.6); white-space:nowrap; }
  .bl-fi-p1 { top:14%;  left:6%;  animation:bl-fip-up 3.6s ease-in-out infinite; }
  .bl-fi-p2 { top:14%;  right:6%; animation:bl-fip-dn 3.0s ease-in-out infinite 0.4s; }
  .bl-fi-p3 { bottom:18%; left:8%; animation:bl-fip-dn 3.9s ease-in-out infinite 0.8s; }
  .bl-fi-p4 { bottom:18%; right:8%;animation:bl-fip-up 3.3s ease-in-out infinite 1.2s; }
  @keyframes bl-fip-up { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }
  @keyframes bl-fip-dn { 0%,100%{transform:translateY(0)} 50%{transform:translateY( 6px)} }

  /* animated traffic line */
  .bl-fi-chart { position:absolute; bottom:0; left:0; right:0; height:60px; pointer-events:none; }
  .bl-fi-line { stroke-dasharray:300; stroke-dashoffset:300; animation:bl-fi-draw 2s ease forwards 0.5s; }
  @keyframes bl-fi-draw { to{stroke-dashoffset:0} }

  /* corner stat badges */
  .bl-fi-stat { position:absolute; z-index:3; display:flex; flex-direction:column; align-items:center; }
  .bl-fi-stat-num { font-family:'Bebas Neue',monospace; font-size:20px; color:#FFD600; line-height:1; }
  .bl-fi-stat-lbl { font-family:'Space Mono',monospace; font-size:7px; font-weight:700; letter-spacing:0.12em; color:rgba(255,255,255,0.4); text-transform:uppercase; margin-top:2px; }
  .bl-fi-s1 { left:10%; bottom:28%; animation:bl-fip-up 4s ease-in-out infinite 0.3s; }
  .bl-fi-s2 { right:10%; bottom:28%; animation:bl-fip-dn 3.5s ease-in-out infinite 0.9s; }
  .bl-featured-body { background: #fff; padding: 48px 40px; display: flex; flex-direction: column; justify-content: space-between; }
  .bl-post-cat { font-family: 'Space Mono', monospace; font-size: 9px; font-weight: 700; letter-spacing: 0.22em; text-transform: uppercase; color: #1B2FE8; margin-bottom: 16px; }
  .bl-post-title { font-family: 'Bebas Neue', monospace; font-size: clamp(28px,3.5vw,44px); letter-spacing: 0.02em; color: #1a1a1a; line-height: 1.05; margin-bottom: 16px; }
  .bl-post-excerpt { font-family: 'Space Mono', monospace; font-size: 10px; line-height: 2; color: #888; margin-bottom: 32px; flex: 1; }
  .bl-post-meta { display: flex; align-items: center; justify-content: space-between; padding-top: 20px; border-top: 1px solid #E8E4DC; }
  .bl-post-author { font-family: 'Space Mono', monospace; font-size: 9px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: #999; }
  .bl-post-date { font-family: 'Space Mono', monospace; font-size: 9px; color: #bbb; letter-spacing: 0.08em; }
  .bl-read-btn { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.15em; text-transform: uppercase; background: #1a1a1a; color: #fff; border: none; padding: 10px 22px; cursor: pointer; text-decoration: none; display: inline-block; transition: background 0.2s; border-radius: 2px; }
  .bl-read-btn:hover { background: #1B2FE8; }

  /* ── POSTS GRID ── */
  .bl-grid-section { background: #F9F7F4; padding: 20px 40px 100px; }
  .bl-grid-inner { max-width: 1100px; margin: 0 auto; }
  .bl-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 1px; background: #E8E4DC; border: 1px solid #E8E4DC; }
  .bl-card { background: #F9F7F4; padding: 36px 28px; display: flex; flex-direction: column; transition: background 0.2s; cursor: pointer; }
  .bl-card:hover { background: #fff; }
  .bl-card-band { height: 3px; width: 40px; margin-bottom: 24px; }
  .bl-card-cat { font-family: 'Space Mono', monospace; font-size: 9px; font-weight: 700; letter-spacing: 0.2em; text-transform: uppercase; color: #999; margin-bottom: 12px; }
  .bl-card-title { font-family: 'Bebas Neue', monospace; font-size: 24px; letter-spacing: 0.04em; color: #1a1a1a; margin-bottom: 12px; line-height: 1.1; }
  .bl-card-excerpt { font-family: 'Space Mono', monospace; font-size: 10px; line-height: 1.9; color: #888; margin-bottom: 24px; flex: 1; }
  .bl-card-footer { display: flex; align-items: center; justify-content: space-between; padding-top: 16px; border-top: 1px solid #E8E4DC; }
  .bl-card-date { font-family: 'Space Mono', monospace; font-size: 8px; color: #bbb; letter-spacing: 0.1em; text-transform: uppercase; }
  .bl-card-arrow { font-family: 'Space Mono', monospace; font-size: 12px; font-weight: 700; color: #1B2FE8; }

  /* ── TOPICS ── */
  .bl-topics-section {
    background: linear-gradient(160deg, #1C1C20 0%, #16161A 60%, #1A1620 100%);
    padding: 60px 40px; border-top: 1px solid rgba(255,214,0,0.1);
    position: relative; overflow: hidden;
  }
  .bl-topics-section::before {
    content: ''; position: absolute; inset: 0;
    background: radial-gradient(ellipse 55% 50% at 70% 50%, rgba(255,214,0,0.06) 0%, transparent 70%);
    pointer-events: none;
  }
  .bl-topics-section::after {
    content: ''; position: absolute;
    top: 0; bottom: 0; left: -55%; width: 55%;
    background: linear-gradient(90deg, transparent 0%, rgba(255,214,0,0.05) 30%, rgba(27,47,232,0.07) 55%, rgba(255,214,0,0.05) 75%, transparent 100%);
    animation: bl-wave-pass 7s linear infinite;
    pointer-events: none; z-index: 0;
  }
  @keyframes bl-wave-pass { from{left:-55%} to{left:155%} }
  .bl-topics-inner { max-width: 1100px; margin: 0 auto; position: relative; z-index: 1; }
  .bl-topics-title { font-family: 'Bebas Neue', monospace; font-size: clamp(40px,5vw,68px); letter-spacing: 0.02em; color: #fff; margin-bottom: 8px; }
  .bl-topics-title em { color: #FFD600; font-style: normal; }
  .bl-topics-sub { font-family: 'Space Mono', monospace; font-size: 10px; letter-spacing: 0.2em; color: rgba(255,255,255,0.4); text-transform: uppercase; margin-bottom: 56px; }
  .bl-topics-list { display: flex; flex-wrap: wrap; gap: 12px; }
  .bl-topic-tag {
    font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700;
    letter-spacing: 0.15em; text-transform: uppercase;
    border: 1px solid rgba(255,255,255,0.15); padding: 10px 22px;
    color: rgba(255,255,255,0.55); cursor: pointer;
    transition: color 0.2s, border-color 0.2s, background 0.2s;
  }
  .bl-topic-tag:hover { color: #FFD600; border-color: rgba(255,214,0,0.4); background: rgba(255,214,0,0.05); }

  /* REVEAL */
  .bl-reveal { opacity: 0; transform: translateY(28px); transition: opacity 0.7s ease, transform 0.7s ease; }
  .bl-reveal.visible { opacity: 1; transform: translateY(0); }

  @media (max-width: 900px) {
    .bl-featured-card { grid-template-columns: 1fr; }
    .bl-grid { grid-template-columns: repeat(2,1fr); }
  }
  @media (max-width: 600px) {
    .bl-grid { grid-template-columns: 1fr; }
    .bl-featured-section, .bl-grid-section, .bl-topics-section { padding-left: 20px; padding-right: 20px; }
  }
`;

function injectStyle(id, css) {
  if (typeof document === 'undefined') return;
  if (document.getElementById(id)) return;
  const el = document.createElement('style');
  el.id = id; el.textContent = css;
  document.head.appendChild(el);
}

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.bl-reveal');
    const io = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.08 }
    );
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
}

const MARQUEE = [
  'SEO Insights', 'Content Strategy', 'Paid Media', 'Social Trends', 'Analytics', 'Growth Hacks',
  'SEO Insights', 'Content Strategy', 'Paid Media', 'Social Trends', 'Analytics', 'Growth Hacks',
];

const FEATURED = {
  category: 'SEO Strategy',
  title: 'How to Rank #1 on Google in 2026 — The Complete Guide',
  excerpt: 'Search has evolved dramatically. AI Overviews, zero-click results and intent-driven indexing mean that the old rules no longer apply. In this deep-dive, we break down exactly what it takes to dominate SERPs in 2026 — from technical foundations to E-E-A-T signals.',
  author: 'Arjun Sharma',
  date: 'Mar 22, 2026',
  imgText: 'SEO',
};

const POSTS = [
  { band: '#1B2FE8', cat: 'Paid Ads',       title: 'Meta Ads in 2026: What Changed and How to Adapt',            excerpt: 'Advantage+ campaigns, AI creative and new attribution windows have reshaped the Meta advertising landscape. Here\'s your updated playbook.',   date: 'Mar 18, 2026' },
  { band: '#FFD600', cat: 'Content',         title: '10 Content Formats That Drive the Most Organic Traffic',     excerpt: 'From comparison pages to original research, we analysed 500 campaigns to find the content types that consistently win in search.',           date: 'Mar 14, 2026' },
  { band: '#1a1a1a', cat: 'Social Media',    title: 'LinkedIn Growth Strategy for B2B Brands in 2026',            excerpt: 'Organic reach on LinkedIn is at an all-time high for thought-leadership content. Here\'s how to capitalise before the algorithm shifts.',  date: 'Mar 10, 2026' },
  { band: '#1B2FE8', cat: 'Email Marketing', title: 'Why Your Email Open Rates Are Dropping and How to Fix Them', excerpt: 'Apple MPP, Gmail tab filters and AI spam detection are all working against you. We share what\'s actually moving the needle in 2026.',     date: 'Mar 06, 2026' },
  { band: '#FFD600', cat: 'Analytics',       title: 'GA4 Mastery: Setting Up Conversion Tracking the Right Way',  excerpt: 'Most GA4 setups are incomplete. We walk through the events, audiences and reports that actually help you make better marketing decisions.',    date: 'Feb 28, 2026' },
  { band: '#1a1a1a', cat: 'Growth',          title: 'How We Grew a Brand from 0 to 50K Monthly Visitors in 6 Months', excerpt: 'A transparent, step-by-step case study of the exact strategy, tools and content calendar we used for a D2C client in the fitness space.', date: 'Feb 22, 2026' },
];

const TOPICS = [
  'SEO & Search', 'Google Ads', 'Meta Ads', 'LinkedIn Marketing', 'Content Strategy',
  'Email Campaigns', 'Conversion Rate Optimisation', 'Web Analytics', 'Social Media',
  'Brand Strategy', 'Influencer Marketing', 'Video Marketing', 'Local SEO', 'E-commerce Growth',
];

export default function Blog() {
  useEffect(() => { injectStyle('bl-styles', STYLE); }, []);
  useReveal();

  return (
    <div className="bl-root">

      {/* HERO */}
      <section className="bl-hero">
        <div className="bl-hero-inner">
          <div className="bl-hero-text">
            <div className="bl-eyebrow bl-reveal">Digital Marketing Insights</div>
            <h1 className="bl-hero-title bl-reveal">
              STRATEGY.<br />
              <span className="bl-cycle">
                <span className="bl-cycle-spacer">PLAYBOOKS.</span>
                {['INSIGHTS.','TACTICS.','PLAYBOOKS.','RESEARCH.','CASE STUDIES.'].map((w,i) => (
                  <span key={i} className={`bl-cycle-word bl-cw-${i}`}>{w}</span>
                ))}
              </span>
              <br />RESULTS.
            </h1>
            <p className="bl-hero-desc bl-reveal">
              In-depth articles, case studies and playbooks on SEO, paid ads, social media,
              content marketing and everything in between — written by practitioners, not theorists.
            </p>
          </div>

          {/* Right animated dashboard visual */}
          <div className="bl-hero-visual">
            <div className="bl-vis-glow" />
            <div className="bl-vis-card">
              <div className="bl-vis-card-hdr">
                <div className="bl-vis-card-title">Content Performance</div>
                <div className="bl-vis-live"><div className="bl-vis-live-dot" /> Live</div>
              </div>
              <div className="bl-vis-bars">
                <div className="bl-vis-bar-col">
                  <div className="bl-vis-bar bl-bar-1" />
                  <div className="bl-vis-bar-lbl">Traffic</div>
                </div>
                <div className="bl-vis-bar-col">
                  <div className="bl-vis-bar bl-bar-2" />
                  <div className="bl-vis-bar-lbl">Leads</div>
                </div>
                <div className="bl-vis-bar-col">
                  <div className="bl-vis-bar bl-bar-3" />
                  <div className="bl-vis-bar-lbl">Revenue</div>
                </div>
              </div>
              <div className="bl-vis-metrics">
                <div className="bl-vis-metric">
                  <div className="bl-vis-metric-num bl-mn-1">12M+</div>
                  <div className="bl-vis-metric-lbl">Reach</div>
                </div>
                <div className="bl-vis-metric">
                  <div className="bl-vis-metric-num bl-mn-2">3.8×</div>
                  <div className="bl-vis-metric-lbl">ROI</div>
                </div>
                <div className="bl-vis-metric">
                  <div className="bl-vis-metric-num bl-mn-3">94%</div>
                  <div className="bl-vis-metric-lbl">Retain</div>
                </div>
              </div>
            </div>
            <div className="bl-vis-float bl-vf-1">🔥 <span>#1</span> SEO Ranking</div>
            <div className="bl-vis-float bl-vf-2">📈 <span>+340%</span> Organic Growth</div>
            <div className="bl-vis-float bl-vf-3">✍️ <span>180+</span> Case Studies</div>
          </div>
        </div>
      </section>

      {/* MARQUEE */}
      <div className="bl-marquee-bar">
        <div className="bl-marquee-track">
          {MARQUEE.map((item, i) => (
            <span key={i} className="bl-marquee-item">{item}<span className="bl-mq-dot" /></span>
          ))}
        </div>
      </div>

      {/* FEATURED */}
      <section className="bl-featured-section">
        <div className="bl-featured-inner">
          <p className="bl-section-eyebrow bl-reveal">Editor's Pick</p>
          <h2 className="bl-section-title bl-reveal">Featured <em>Article</em></h2>
          <div className="bl-featured-card bl-reveal">
            <div className="bl-featured-img">
              <div className="bl-fi-grid" />
              <div className="bl-fi-ghost">SEO</div>

              {/* floating keyword pills */}
              <div className="bl-fi-pill bl-fi-p1">Keywords</div>
              <div className="bl-fi-pill bl-fi-p2">Backlinks</div>
              <div className="bl-fi-pill bl-fi-p3">Core Web Vitals</div>
              <div className="bl-fi-pill bl-fi-p4">E-E-A-T</div>

              {/* corner stats */}
              <div className="bl-fi-stat bl-fi-s1">
                <div className="bl-fi-stat-num">98</div>
                <div className="bl-fi-stat-lbl">DA Score</div>
              </div>
              <div className="bl-fi-stat bl-fi-s2">
                <div className="bl-fi-stat-num">12M+</div>
                <div className="bl-fi-stat-lbl">Impressions</div>
              </div>

              {/* central glowing content */}
              <div className="bl-fi-center">
                <div className="bl-fi-seo">SEO</div>
                <div className="bl-fi-rank">
                  <div className="bl-fi-rank-num">#1</div>
                  <div className="bl-fi-rank-lbl">Google Ranking</div>
                </div>
              </div>

              {/* animated rising traffic line */}
              <svg className="bl-fi-chart" viewBox="0 0 400 60" preserveAspectRatio="none">
                <defs>
                  <linearGradient id="blLineGrad" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stopColor="rgba(255,214,0,0)" />
                    <stop offset="100%" stopColor="rgba(255,214,0,0.8)" />
                  </linearGradient>
                  <linearGradient id="blFillGrad" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="rgba(255,214,0,0.15)" />
                    <stop offset="100%" stopColor="rgba(255,214,0,0)" />
                  </linearGradient>
                </defs>
                <path d="M0 55 Q60 50 100 45 Q160 38 200 30 Q260 18 320 10 Q360 5 400 2 L400 60 L0 60 Z" fill="url(#blFillGrad)" />
                <path className="bl-fi-line" d="M0 55 Q60 50 100 45 Q160 38 200 30 Q260 18 320 10 Q360 5 400 2" fill="none" stroke="url(#blLineGrad)" strokeWidth="2" />
              </svg>
            </div>
            <div className="bl-featured-body">
              <div>
                <div className="bl-post-cat">{FEATURED.category}</div>
                <div className="bl-post-title">{FEATURED.title}</div>
                <p className="bl-post-excerpt">{FEATURED.excerpt}</p>
              </div>
              <div>
                <div className="bl-post-meta">
                  <span className="bl-post-author">{FEATURED.author}</span>
                  <span className="bl-post-date">{FEATURED.date}</span>
                </div>
                <div style={{ marginTop: 20 }}>
                  <a href="#" className="bl-read-btn">Read Article →</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* POSTS GRID */}
      <section className="bl-grid-section">
        <div className="bl-grid-inner">
          <p className="bl-section-eyebrow bl-reveal">Latest Posts</p>
          <h2 className="bl-section-title bl-reveal">Recent <em>Articles</em></h2>
          <div className="bl-grid bl-reveal">
            {POSTS.map((p, i) => (
              <div className="bl-card" key={i}>
                <div className="bl-card-band" style={{ background: p.band }} />
                <div className="bl-card-cat">{p.cat}</div>
                <div className="bl-card-title">{p.title}</div>
                <p className="bl-card-excerpt">{p.excerpt}</p>
                <div className="bl-card-footer">
                  <span className="bl-card-date">{p.date}</span>
                  <span className="bl-card-arrow">→</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TOPICS */}
      <section className="bl-topics-section">
        <div className="bl-topics-inner">
          <h2 className="bl-topics-title bl-reveal">Browse by <em>Topic</em></h2>
          <p className="bl-topics-sub bl-reveal">Filter articles by category</p>
          <div className="bl-topics-list bl-reveal">
            {TOPICS.map((t, i) => (
              <span key={i} className="bl-topic-tag">{t}</span>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
